"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationArrows = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _react = require("react");
var _common = require("../../common");
var _styles = require("./styles");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const NavigationArrows = ({
  instanceRef,
  lastSlideVisible,
  slider,
  slidesCount,
  navigation,
  pagination
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [isAtTheEnd, setIsAtTheEnd] = (0, _react.useState)(false);
  const [isAtTheStart, setIsAtTheStart] = (0, _react.useState)(true);
  const currentSlide = (0, _lodash.default)(instanceRef, 'current.track.details.rel', 0);
  const createHandler = (0, _react.useCallback)(type => event => {
    event.stopPropagation();
    const index = (0, _utils.getIndex)({
      instanceRef,
      isAtTheEnd,
      isAtTheStart,
      setIsAtTheEnd,
      setIsAtTheStart,
      slider,
      slidesCount,
      type
    });
    instanceRef.current?.moveToIdx(index);
  }, [instanceRef, isAtTheEnd, isAtTheStart, slider, slidesCount]);
  const onNextClick = createHandler('next');
  const onPreviousClick = createHandler('previous');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _utils.shouldShowPreviousArrow)({
      currentSlide,
      slider
    }) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PreviousArrow, {
      "aria-label": "\u2190",
      "data-testid": getTestId(_common.CAROUSEL_PREVIOUS_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      size: navigation?.size,
      onClick: onPreviousClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {})
    }) : null, (0, _utils.shouldShowNextArrow)({
      lastSlideVisible,
      slidesCount,
      currentSlide,
      slider
    }) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.NextArrow, {
      "aria-label": "\u2192",
      "data-testid": getTestId(_common.CAROUSEL_NEXT_ARROW),
      height: navigation?.height,
      position: pagination?.position,
      size: navigation?.size,
      onClick: onNextClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})
    }) : null]
  });
};
exports.NavigationArrows = NavigationArrows;
